import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonDesktopHeader from '@r1-frontend/entities/Layout/Header/desktop/components/CommonDesktopHeader';
import CommonMobileHeader from '@r1-frontend/entities/Layout/Header/mobile/components/CommonMobileHeader';
import ProfileContainer from '@r1-frontend/entities/Layout/Header/mobile/components/ProfileContainer';
import getAgreements from '@r1-frontend/entities/stores/auth/actions/getAgreements';
import { selectAuthMenu } from '@r1-frontend/entities/stores/city/selectors/selectMenu';

export const AuthHeader = () => {
    const newMenuItems = useSelector(selectAuthMenu);

    const dispatch = useDispatch();

    const CommonActions = useMemo(() => <ProfileContainer/>, []);

    useEffect(() => {
        dispatch(getAgreements());
    }, [dispatch]);

    return (
        <>
            <CommonDesktopHeader
                items={newMenuItems}
                ClientActions={CommonActions}
                isAuth={true}
            />
            <CommonMobileHeader
                items={newMenuItems}
                CommonActions={{ Actions: CommonActions }}
                isAuth={true}
            />
        </>
    );
};
